import { render } from "./zqTopicCheck.vue?vue&type=template&id=a494001a&scoped=true"
import script from "./zqTopicCheck.vue?vue&type=script&lang=js"
export * from "./zqTopicCheck.vue?vue&type=script&lang=js"

import "./zqTopicCheck.vue?vue&type=style&index=0&id=a494001a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a494001a"]])

export default __exports__